import { useContext } from 'react';

import { AppContext } from '@/providers/AppProvider';

const useAppProvider = () => {
    const ctx = useContext(AppContext);

    return {
        ...ctx,
    };
};

export default useAppProvider;
